import React from 'react'
import ReactDOM from 'react-dom/client'
import * as Sentry from '@sentry/react'
import App from './App'
import useAlarm from './hooks/useAlarm'
import useNotifications from './hooks/useNotifications'
import './index.css'

// ── Sentry error tracking ────────────────────────────────────────────────────
if (import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0.1,
  })
}

// Register the service worker for PWA / push notification support
if ('serviceWorker' in navigator) {
  // Listen for messages from the service worker (alarm triggers)
  navigator.serviceWorker.addEventListener('message', (event) => {
    if (event.data?.type === 'ALERT_TRIGGERED') {
      const payload = event.data.payload
      useAlarm.getState().trigger(payload)
      // Also fire a native desktop notification (visible when app is backgrounded)
      useNotifications.getState().showNotification(payload)
    }
  })

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        console.log('[SW] Registered:', reg.scope)
        // Auto-subscribe to push if permission was already granted
        if (Notification.permission === 'granted') {
          useNotifications.getState().subscribeToPush()
        }
      })
      .catch((err) => console.error('[SW] Registration failed:', err))
  })
}

// Dev helper: test alarm from browser console with window.testAlarm()
if (import.meta.env.DEV) {
  window.testAlarm = (sound) => {
    if (sound) useAlarm.getState().setSelectedSound(sound)
    const data = {
      coin: 'Bitcoin',
      condition: 'above',
      target: 100000,
      current: 105234.56,
    }
    useAlarm.getState().trigger(data)
    useNotifications.getState().showNotification(data)
  }
  console.log(
    '%c[Alarm Test] %cRun %cwindow.testAlarm()%c in console to test. ' +
    'Sounds: "siren", "buzzer", "bell", "airhorn"',
    'color:#f59e0b;font-weight:bold', 'color:#eaecef', 'color:#0ecb81;font-weight:bold', 'color:#eaecef'
  )
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
